import React from "react";
import {
  Container,
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./Constructor.css";

import avatar from "../../assets/images/avantar.png";
import serviceicon from "../../assets/images/serviceicon.png";
import { Room, Today } from "@material-ui/icons";
import { Edit, NavigateNext, Schedule } from "@material-ui/icons";

export default function Constructor() {
  let { Constructor } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [Constructor]);
  const [day, setDay] = React.useState("");
  const handleChangeDay = (event) => {
    setDay(event.target.value);
  };
  const [tab, setTab] = React.useState("Latest");
  const handleChangeTab = (text) => {
    setTab(text);
  };
  return (
    <React.Fragment>
      <Header />
      <Container>
        <div className="theConstructorSection">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={5} md={3}>
              <div className="theOutterLayer">
                <div className="theUserCard">
                  <div className="theCardHeader">
                    <div className="theAvatar">
                      {/* <img src={avatar} /> */}
                      <p>Name</p>
                      <p>RM 9,000.00</p>
                    </div>
                  </div>
                  <div className="theCardBody">
                    <Link className="theFlexBtn">
                      <p>See Balance Detail</p>
                      <NavigateNext className="theIcon" />
                    </Link>
                  </div>
                </div>
                <div className="theDownload">
                  <Link className="theDownloadLink">
                    <p>Download Bank Statement</p>
                    <NavigateNext className="theIcon" />
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={7} md={9}>
              <div className="theCardCon">
                <div className="theCardConHeader">
                  <p>Service List</p>
                </div>
                <div className="theCardConBody">
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6}>
                      <Link className="theServiceCard" to="/constructorservicedetail">
                        <div className="thePadd">
                          <div className="theServiceDetail">
                            <p className="service">
                              Chemical Maintanance Service
                            </p>
                            <div className="theFlex">
                              <Room className="theIcon" />
                              <p className="area">Area Name</p>
                            </div>
                            <div className="theFlex_">
                              <Today className="theIcon" />
                              <p>2021-06-04 10:00AM</p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </Grid>
                    
                    
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
          <div className="theTransaction">
            <div className="theCardCon">
              <div className="theCardConHeader">
                <p>Debit Card</p>
              </div>
              <div className="theCardConBodyDebit">
                <div className="theSubHeader">
                  <div className="theTabList">
                    <Link
                      className={
                        tab === "Latest" ? "theLastestActive" : "theLastest"
                      }
                      onClick={() => handleChangeTab("Latest")}
                    >
                      Latest
                    </Link>
                    <Link
                      className={
                        tab === "Archived" ? "theArchivedActive" : "theArchived"
                      }
                      onClick={() => handleChangeTab("Archived")}
                    >
                      Archived
                    </Link>
                  </div>
                  <div className="theFilterDay">
                    <FormControl className="">
                      <Select
                        value={day}
                        onChange={handleChangeDay}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={"Last 7 days"}>Last 7 days</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="theTransactionList">
                  {tab === "Latest" && (
                    <>
                      <div className="theList">
                        <div className="thePadd">
                          <div className="theFlex">
                            <p className="service">Service Fee</p>
                            <p className="price">+RM 9,000.00</p>
                          </div>
                          <div className="theFlex">
                            <p className="order">Order no. 123456789</p>
                            <p className="date">22 Apr</p>
                          </div>
                        </div>
                      </div>
                      <div className="theList">
                        <div className="thePadd">
                          <div className="theFlex">
                            <p className="service">Service Fee</p>
                            <p className="price">+RM 9,000.00</p>
                          </div>
                          <div className="theFlex">
                            <p className="order">Order no. 123456789</p>
                            <p className="date">22 Apr</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {tab === "Archived" && (
                    <>
                      <div className="theList">
                        <div className="thePadd">
                          <div className="theFlex">
                            <p className="service">Service Fee</p>
                            <p className="price">+RM 9,000.00</p>
                          </div>
                          <div className="theFlex">
                            <p className="order">Order no. 123456789</p>
                            <p className="date">22 Apr</p>
                          </div>
                        </div>
                      </div>
                      <div className="theList">
                        <div className="thePadd">
                          <div className="theFlex">
                            <p className="service">Service Fee</p>
                            <p className="price">+RM 9,000.00</p>
                          </div>
                          <div className="theFlex">
                            <p className="order">Order no. 123456789</p>
                            <p className="date">22 Apr</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </React.Fragment>
  );
}
